import { UUID } from 'v2/core/entities/uuid';
import useGetIntegrationEditFormData from 'v2/core/repository/edge-server/integrations/editIntegrations/useGetIntegrationEditFormData';

export function useFetchDiscordChannels(integrationID: UUID) {
  const { data, status } = useGetIntegrationEditFormData({
    integrationID,
  });

  return {
    data: data?.discord?.channelsInGuild ?? [],
    status,
  };
}
